import React from 'react';
import cn from 'classnames';
import { Trans, useTranslation } from 'next-i18next';

import { ArrowDownMonoIcon, Button } from '@catawiki/cata-style';

import { StartSellingButton } from '../StartSellingButton';
import styles from './Hero.module.scss';
import { HeroImage } from './HeroImage';
import { WHY_SELL_AT_CATAWIKI_ID } from '../../constants';
import { StrongBrandContainer } from '../StrongBrandContainer';

const scrollDownClickHandler = (e: React.MouseEvent) => {
  e.preventDefault();
  document
    .getElementById(WHY_SELL_AT_CATAWIKI_ID)
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

type HeroProps = {
  isLoggedIn: boolean;
};

export const Hero = ({ isLoggedIn }: HeroProps) => {
  const { t } = useTranslation();
  return (
    <section
      className={cn(
        styles.hero,
        'tw:flex tw:justify-between u-m-t-xxl-2 desktop'
      )}
    >
      <HeroImage />

      <h1 className={cn(styles.landingTitle, 'u-typography-h1')}>
        <Trans
          i18nKey="seller_register.hero.title"
          components={{
            strong: <StrongBrandContainer className="u-typography-h1-serif" />,
          }}
        />
      </h1>

      <div className={styles.ctaSection}>
        <Trans t={t}>
          <p className="u-typography-h4 u-m-t-xl u-color-secondary">
            {t('seller_register.hero.subtitle')}
          </p>
        </Trans>

        <StartSellingButton isLoggedIn={isLoggedIn} />
      </div>
      <div className="u-m-t-xl">
        <Button
          variant="tertiary"
          icon={() => <ArrowDownMonoIcon className={styles.scrollDownArrow} />}
          onClick={scrollDownClickHandler}
        />
      </div>
    </section>
  );
};
